function LoadingSpinner({ message }) {
  return (
    <div className="loading-container">
      {message && <p>{message}</p>}
      <div className="loading-spinner" />
    </div>
  );
}

export { LoadingSpinner };
